import { CatalogueMenu } from 'types/api/product.type';

export type CategoryGroup = { label: string; value: string };

/**
 * Across genders, different category codes can share one label (e.g.
 * "POLO - T-SHIRT" and "T-SHIRT - POLO"). Returns one entry per label, ordered
 * by menu position; its value lists every code, comma-separated, so a template
 * for that label covers all of them.
 */
export const groupCategoriesByLabel = (
  genres: CatalogueMenu[],
  toLabel: (category: string) => string
): CategoryGroup[] => {
  const byLabel = new Map<string, { codes: Set<string>; order: number }>();
  genres.forEach((g) => {
    g.nodeName2.forEach((cat) => {
      const label = toLabel(cat.name);
      const entry = byLabel.get(label);
      if (!entry) {
        byLabel.set(label, { codes: new Set([cat.name]), order: cat.order });
        return;
      }
      entry.codes.add(cat.name);
      entry.order = Math.min(entry.order, cat.order);
    });
  });
  return Array.from(byLabel.entries())
    .sort((a, b) => a[1].order - b[1].order)
    .map(([label, { codes }]) => ({ label, value: Array.from(codes).join(',') }));
};
